var _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 147,
    viewBox: "0 0 150 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6750_19956)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.855083
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6750_19956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 125,
    height: 124
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.855083
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1086 0L75.1748 0.00701517C110.395 0.469642 149.1 23.7767 149.1 58.9217L149.091 59.9846C148.524 94.9943 119.967 123.2 84.8217 123.2L83.7603 123.196C48.8556 122.944 25.8999 110.136 25.8999 74.9911C25.8999 39.4911 38.6086 0 74.1086 0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6750_19956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6912 126.408H152.309V-3.20879H22.6912V126.408Z",
    fill: "#993F7F"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.617574
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6750_19956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 18,
    width: 136,
    height: 129
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.617574
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.936 18.2L70.006 18.207C105.354 18.6705 144.2 42.022 144.2 77.2335L144.195 78.3001C143.836 113.481 125.713 147 90.44 147L89.3684 146.993C53.9152 146.529 9.80005 123.178 9.80005 87.9668C9.80005 52.3997 33.3069 18.2 68.936 18.2Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6750_19956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57983 150.215H147.42V14.9854H6.57983V150.215Z",
    fill: "#F05B60"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6750_19956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 124,
    height: 124
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.855083
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9218 6.3L59.9848 6.30542C94.9941 6.66305 123.2 24.7203 123.2 59.8653L123.188 60.9298C122.411 96.0445 83.3533 129.5 48.2088 129.5L47.1506 129.491C12.4557 128.924 0 100.367 0 65.2217C0 29.7217 23.422 6.3 58.9218 6.3Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6750_19956)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.586642,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.2085 132.709H126.408V3.09151H-3.2085V132.709Z",
    fill: "#BB84C2"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6750_19956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 27,
    width: 48,
    height: 93
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1001 27.3H98.7001V119.7H51.1001V27.3Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6750_19956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7874 119.7H57.0143C53.7617 119.7 51.1001 117.015 51.1001 113.731V33.2703C51.1001 29.988 53.7617 27.3 57.0143 27.3H92.7874C96.0385 27.3 98.7001 29.988 98.7001 33.2703V113.731C98.7001 117.015 96.0385 119.7 92.7874 119.7Z",
    fill: "#233135"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4139 115.5C54.9646 115.5 54.6001 114.998 54.6001 114.38V33.3187C54.6001 32.7024 54.9646 32.2 55.4139 32.2H94.3871C94.835 32.2 95.2001 32.7024 95.2001 33.3187V114.38C95.2001 114.998 94.835 115.5 94.3871 115.5H55.4139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6664 89.5239H63.9342C62.59 89.5239 61.5 88.4488 61.5 87.1217V60.4261C61.5 59.0996 62.59 58.0239 63.9342 58.0239H85.6664C87.0106 58.0239 88.1 59.0996 88.1 60.4261V87.1217C88.1 88.4488 87.0106 89.5239 85.6664 89.5239Z",
    fill: "#EF5489"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.064 74.7342C79.7906 76.9165 81.2105 78.7203 81.4709 79.0761C82.2512 80.1676 82.5823 81.0227 81.4229 82.0654C80.359 83.039 79.0573 82.304 78.2058 81.3304C77.8979 80.9751 76.9047 79.7165 75.6272 78.1269C75.3199 77.7478 74.5865 77.0117 73.7345 77.9853C72.2203 79.7647 71.0378 81.1644 70.7536 81.4245C69.8073 82.3981 69.0039 82.8724 67.7739 81.9005C66.6145 80.9751 67.1343 79.5505 67.9626 78.531C68.2931 78.1269 69.5705 76.5374 71.2028 74.6634C71.9373 73.8088 71.5113 72.9536 71.2508 72.5978C69.5943 70.4863 68.2225 68.6831 67.9626 68.2796C67.2767 67.1644 67.7739 66.0491 68.4123 65.5516C69.0508 65.0297 70.3757 64.8863 71.1796 65.9551C71.417 66.3109 72.5283 67.7107 73.9006 69.4668C74.1605 69.7983 75.0125 70.1786 75.651 69.4192C77.3307 67.4494 78.7268 65.8831 79.0573 65.5748C80.0511 64.697 81.2579 65.0053 81.8726 65.5516C82.5116 66.1199 82.8665 67.4262 81.9195 68.4224C81.5653 68.7783 80.0748 70.5345 78.3002 72.6227C77.3064 73.8088 77.8273 74.4259 78.064 74.7342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6750_19956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.1,
    height: 147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInactive);
export default __webpack_public_path__ + "static/media/AccountInactive.839f696049dddec2c9fd03d7e23dbfee.svg";
export { ForwardRef as ReactComponent };